import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { fetchBrightPearlData, configureStore, resetConfigureState } from './brightpearlSlice';
import ShipmentUpdateFlag from '../../../../General/ShipmentUpdateFlag';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    height: '100%'
}));

const BrightpearlIntegration = ({ storeName, storeId }) => {
    const dispatch = useDispatch();
    const integratedStore = useSelector(state => state.integrated);
    const profile = useSelector(state => state.auth);
    const progress = useSelector(state => state.brightpearl && state.brightpearl.progress);
    const configure = useSelector(state => state.brightpearl && state.brightpearl.configure);

    const [accountCode, setAccountCode] = useState("");
    const [isUpdateShipment, setIsUpdateShipment] = useState(progress && progress.data && progress.data.is_update_shipment)
    const [isCreateShipmentStatus, setIsCreateShipmentStatus] = useState(progress && progress.data && progress.data.is_update_shipment_on_create)
    const [isManifestCloseStatus, setIsManifestCloseStatus] = useState(progress && progress.data && progress.data.is_update_shipment_on_close)
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [btnConfigDisabled, setBtnConfigDisabled] = useState(true);
    const [authorizeUrl, setAuthorizeUrl] = useState('');
    const [alert, setAlert] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const params = new URLSearchParams(window.location.search)
    let storeParam = params.get('account')

    useEffect(() => {
        if (progress && progress.data) {
            setIsUpdateShipment(progress && progress.data && progress.data.is_update_shipment);
            setIsCreateShipmentStatus(progress && progress.data && progress.data.is_update_shipment_on_create);
            setIsManifestCloseStatus(progress && progress.data && progress.data.is_update_shipment_on_close);
        }
    }, [progress && progress.data]);

    useEffect(() => {
        if (configure && configure.message) {
            setAlert(true)
            setSnackOpen(true)
        } else if (configure && configure.hasErrors == true) {
            setAlert(true)
            setSnackOpen(true)
        }
    }, [dispatch, configure && configure.message])

    useEffect(() => {
        let apikey = profile.profile.api_token
        const data = { apikey: apikey, store_name: storeName, store_id: storeId }
        dispatch(fetchBrightPearlData(data));
    }, [dispatch]);

    const handleClose = () => {
        dispatch(resetConfigureState())
        setSnackOpen(false);
        if (storeParam && configure && configure.hasErrors == false) {
            window.location.href = window.location.origin + "/integration/marketplace"
        }
    };

    const inputChange = (e) => {
        let userId = profile.profile.id;
        let account = e.target.value;
        setAccountCode(account)
        let url = "https://oauth.brightpearl.com/authorize/"
            + account + "?response_type=code&client_id=shippingchimp&redirect_uri="
            + process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/bp/callback&state=" + userId;
        setAuthorizeUrl(url);

        let success = false;
        if (integratedStore && integratedStore.data && integratedStore.data.length !== 0) {
            integratedStore.data.map((item) => {
                if (account === item.store_name && item.platform === "BRIGHTPEARL") {
                    setBtnDisabled(true)
                    success = true;
                } else if (success === false && account !== item.store_name) {
                    setBtnDisabled(false)
                }
            })
        } else {
            setBtnDisabled(false)
        }
    }

    const updateCallBackValue = (updateValue) => {
        setIsUpdateShipment(updateValue.is_update_shipment);
        setIsCreateShipmentStatus(updateValue.is_update_shipment_on_create);
        setIsManifestCloseStatus(updateValue.is_update_shipment_on_close);
        setBtnConfigDisabled(false)
    };

    const configurestore = () => {
        let storeDetails = ""
        if (storeName) {
            storeDetails = storeName;
        } else {
            storeDetails = storeParam;
        }
        const data = {
            "store_name": storeDetails,
            'is_update_shipment': isUpdateShipment,
            'is_update_shipment_on_create': isCreateShipmentStatus,
            'is_update_shipment_on_close': isManifestCloseStatus
        }
        dispatch(configureStore(data))
    }

    return (
        <>
            {alert &&
                <Snackbar
                    open={snackOpen}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert
                        variant="filled"
                        severity={configure && configure.hasErrors === true ? "error" : "success"}
                        sx={{ 
                            justifyContent: 'center', 
                            margin: "10px 0",
                            borderRadius: '12px',
                            fontWeight: 600,
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)'
                        }}
                    >
                        <span > {configure && configure.message}</span>
                    </Alert>
                </Snackbar>
            }
            {(!storeParam && !storeName) &&
                <Grid container spacing={0} justifyContent="center" sx={{ my: 4 }}>
                    <Grid item xs={12} sm={10} md={7} lg={6}>
                        <Card
                            sx={{
                                p: { xs: 3, md: 5 },
                                borderRadius: '16px',
                                border: '1px solid #E2E8F0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01)',
                                backgroundColor: '#FFFFFF'
                            }}
                        >
                            <Item>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 3.5 }}>
                                    
                                    {/* App Brand Identity Component Logo Display */}
                                    <Box sx={{ p: 2, backgroundColor: '#F8FAFC', borderRadius: '14px', border: '1px solid #F1F5F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Box
                                            component="img"
                                            src="/assets/images/integration/BRIGHTPEARL.png"
                                            alt="BRIGHTPEARL"
                                            sx={{ width: 'auto', height: '44px', objectFit: 'contain' }}
                                        />
                                    </Box>

                                    {/* Module Context Headline Header Text */}
                                    <Box>
                                        <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '18px', mb: 0.5, letterSpacing: '-0.3px' }}>
                                            Connect Brightpearl Account
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#64748B', maxWidth: '340px', mx: 'auto', lineHeight: 1.5 }}>
                                            Provide your modern Brightpearl merchant organization account identifier code to grant synchronization tokens.
                                        </Typography>
                                    </Box>

                                    {/* Interactive Domain Code Form Action Field */}
                                    <Box className="sc--form--center" sx={{ width: '100%', maxWidth: '420px' }}>
                                        <TextField
                                            id="standard-numbe"
                                            label="Account code"
                                            size="small"
                                            onInput={inputChange}
                                            variant="outlined"
                                            fullWidth
                                            error={btnDisabled && accountCode !== ''}
                                            helperText={btnDisabled && accountCode !== '' ? "this brightpearl account already integrated" : ""}
                                            FormHelperTextProps={{
                                                sx: {
                                                    color: '#B91C1C',
                                                    fontWeight: 500,
                                                    mx: 0.5,
                                                    mt: 0.75
                                                }
                                            }}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '10px',
                                                    '& fieldset': { borderColor: '#E2E8F0' },
                                                    '&:hover fieldset': { borderColor: '#CBD5E1' }
                                                },
                                                '& .MuiInputLabel-root': { color: '#64748B', fontWeight: 500 }
                                            }}
                                        />
                                    </Box>

                                    {/* Authorization Execution Trigger Command Panel */}
                                    <Box className="sc--form--center" sx={{ width: '100%', display: 'flex', justifyContent: 'center', borderTop: '1px solid #F1F5F9', pt: 3 }}>
                                        <Button
                                            variant="contained"
                                            disabled={btnDisabled}
                                            href={authorizeUrl}
                                            target="_blank"
                                            endIcon={<SendOutlinedIcon sx={{ fontSize: '15px !important', ml: 0.5 }} />}
                                            sx={{
                                                px: 5,
                                                py: 1.25,
                                                borderRadius: '8px',
                                                fontWeight: 700,
                                                textTransform: 'none',
                                                fontSize: '13.5px',
                                                boxShadow: 'none',
                                                backgroundColor: '#1976d2',
                                                '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                            }}
                                        >
                                            Authorize
                                        </Button>
                                    </Box>

                                </Box>
                            </Item>
                        </Card>
                    </Grid>
                </Grid>
            }
            {(progress && progress.loading === false) && <>
                {(storeParam || storeName === 'all' || storeName) &&
                    <Grid container spacing={0} justifyContent="center" sx={{ my: 3 }}>
                        <Grid item xs={12} sm={10} md={8}>
                            <Card
                                sx={{
                                    p: { xs: 3, md: 5 },
                                    borderRadius: '16px',
                                    border: '1px solid #E2E8F0',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
                                    backgroundColor: '#FFFFFF'
                                }}
                            >
                                <Item>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0F172A', mb: 0.5 }}>
                                                Configure Store Environment
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#64748B' }}>
                                                Manage synchronization settings and callback event actions.
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                            <TextField
                                                id="standard-numbe"
                                                label="Brightpearl Account"
                                                value={storeName ? storeName : storeParam}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                size="medium"
                                                variant="outlined"
                                                sx={{ 
                                                    width: "100%", 
                                                    maxWidth: '520px',
                                                    '& .MuiOutlinedInput-root': { 
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC'
                                                    }
                                                }}
                                            />
                                        </Box>

                                        <Box sx={{ borderTop: '1px solid #F1F5F9', pt: 2 }}>
                                            <ShipmentUpdateFlag
                                                updateFlag={isUpdateShipment}
                                                onCreateFlag={isCreateShipmentStatus}
                                                onCloseFlag={isManifestCloseStatus}
                                                updateCallBack={updateCallBackValue}
                                                message={"Do you want to update shipment information back to woocommerce account?"}
                                            />
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                            <LoadingButton
                                                variant="contained"
                                                onClick={configurestore}
                                                disabled={btnConfigDisabled}
                                                loading={configure && configure.loading}
                                                sx={{
                                                    px: 5,
                                                    py: 1.25,
                                                    borderRadius: '8px',
                                                    fontWeight: 700,
                                                    textTransform: 'none',
                                                    fontSize: '14px',
                                                    boxShadow: 'none',
                                                    '&:hover': { boxShadow: 'none' }
                                                }}
                                            >
                                                Configure
                                            </LoadingButton>
                                        </Box>
                                    </Box>
                                </Item>
                            </Card>
                        </Grid>
                    </Grid>
                }
            </>
            }
        </>
    )
}

export default BrightpearlIntegration;